<template>
  <div id="records">
      <el-row style="margin-bottom:20px;">
      <el-col class="widthauto" >
        <el-select v-model="searchForm.leaveType" filterable placeholder="请假类别" clearable @change="courseSearch">
          <el-option
            v-for="item in adjustdata"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col class="widthauto" style="margin-left:10px;">
              <el-select v-model="searchForm.status" filterable clearable placeholder="状态" @change="courseSearch">
                <el-option
                  v-for="item in status"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
        </el-col>
    </el-row>
    <el-table
      :data="CourseData"
      ref="CourseData"
      tooltip-effect="dark"
      style="width: 100%"
      v-loading="loading"
      :span-method="objectSpanMethod"
      element-loading-text="数据加载中，请稍等..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
     
      <el-table-column
        
        label="请假类别"
        fixed="left"
        show-overflow-tooltip
        min-width="150"
        align="center"
      >
        <!-- prop="className" -->
        <template slot-scope="scope">
         {{getid(scope.row.leave_type)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="开始日期"
        show-overflow-tooltip
        min-width="100"
        :formatter="dateForma"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="结束日期"
        show-overflow-tooltip
        :formatter="dateForma"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="hour"
        label="时长"
        show-overflow-tooltip
        min-width="100"
        align="center"
      >
         <template slot-scope="scope">
                {{scope.row.hour&&scope.row.hour.toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="hour"
        label="请假班级"
        show-overflow-tooltip
        min-width="100"
        align="center"
      >
       <template slot-scope="scope">
                {{scope.row.classInfo.name}}
                </template></el-table-column>
      <el-table-column
        prop="reason"
        label="原因"
        show-overflow-tooltip
        min-width="100"
        align="center"
      ></el-table-column>
       <el-table-column prop="audit_status" label="状态" show-overflow-tooltip>
             <template slot-scope="scope">
                <span v-if="scope.row.audit_status=='1'">未审核</span>
                <span v-if="scope.row.audit_status=='2'">审核通过</span>
                <span v-if="scope.row.audit_status=='3'">审核失败</span>
                </template>
          </el-table-column>
    </el-table>
    <div class="wrap_footer clearfix">
     
      <div class="right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "records",
  props: ["tabindex"],
  
  data() {
    return {
     CourseData:[],
      searchForm:{
       leaveType:"",
       status:null
      },
      loading:false,
      spanArr:[],
      adjustdata:[],
      total: 0,
      status:[
        {
          text:'未审核',
          value:'1'
        },
         {
          text:'审核通过',
          value:'2'
        },
        {
          text:'审核失败',
          value:'3'
        },
      ],
      pageIndex: 1,
      pageSize: 10,
    };
  },
  async mounted() {
    let me = this;
    me.$watch("tabindex", async function(val, oldval) {
      if (val == '1') {
          me.searchForm.leaveType=null;
          me.CourseData=[];
          await me.gettype();
          await me.leaveRecords();
         
          }
    })
  },
   
  methods: {
   dateForma:function(row,column){
       
        var date = parseInt(row[column.property]);
       
        if(date == undefined){return ''};

        return moment(date).format("YYYY-MM-DD HH:mm:ss")

    },

 getSpanArr(data) {　
      this.spanArr=[];
  for (var i = 0; i < data.length; i++) {
        if (i === 0) {
              this.spanArr.push(1);
              this.pos = 0;
            
        } else {
         
    if (data[i].id === data[i - 1].id) {
               
                this.spanArr[this.pos] += 1;
                this.spanArr.push(0);
              } else {
                this.spanArr.push(1);
                this.pos = i;
              }
        }
    }
},
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
              if (columnIndex === 0||columnIndex === 5||columnIndex === 6) {
                const _row = this.spanArr[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                      rowspan: _row,
                      colspan: _col
                }       
        }
      },
    courseSearch(){
        this.leaveRecords();
    },
     getid(id){
      let res = '';
      let obj = this.adjustdata.find((item) => { 
        return item.value == id
      })
      if (obj != undefined) {
        res = obj.text
      }
   
      return res
    },
    async gettype(){
      let me=this;
      let usertype = await me.$userService.querySysCode('tm','LeaveType');
          if (usertype && usertype.success) {
               me.adjustdata=[];
               let obj=usertype.content.LeaveType;
              obj.forEach(function(item,index){
                 
                   if(item.value=='2' || item.value =='4'|| item.value =='8'){
                   me.adjustdata.push(item);
                 }
               })
          }
    },
    async leaveRecords(){
        let me = this;
        let param=me.searchForm;
        if(me.searchForm.status==""){
          me.searchForm.status=null;
        }
        param.pageIndex=me.pageIndex;
        param.pageSize=me.pageSize;
        let res = await me.$userService.queryLeave(param);
        if(res&&res['success']){
          me.CourseData=[];
          res.content.records.forEach((item,index)=>{
              item.times.forEach((items,indexs)=>{
                    let param={
                      leave_type:item.leave_type,
                      startTime:items.startTime,
                      endTime:items.endTime,
                      id:item.id,
                      hour:items.hours,
                       classInfo:items.classInfo,
                       audit_status:item.audit_status,
                      reason:item.reason
                    }
                     me.CourseData.push(param);
              })
          })
            me.getSpanArr( me.CourseData);
          // me.CourseData=res.content.records;
          me.total=res.content.total;
        }
    },
       //  当前页发生改变
    async handleCurrentChange(page) {
      let me = this;
      me.pageIndex = page;
      await me.leaveRecords();
    },
    //  每页显示条目个数发生改变
    async handleSizeChange(page) {
      let me = this;
      me.pageSize = page;
      await me.leaveRecords();
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/attendance/child/leaveRecords.vue